// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3AWhD","actions":"GroupTable_actions__1lOy0","deleteModalFooter":"GroupTable_deleteModalFooter__1FTc4"};